/*
 * @Description: 
 * @Author: doris_xu
 * @Date: 2025-11-20 15:09:35
 * @LastEditTime: 2025-11-26 16:18:26
 */
/* eslint-disable */
/* tslint:disable */

import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import ExpertApp from "./expert/App";
import reportWebVitals from "./reportWebVitals";
import createStore, { Environment } from "./helpers/create-store";
import { StoreProvider } from "./helpers/store-provider";
import moment from 'moment';
import 'moment/locale/zh-cn';

let envConfig: Environment;
const nodeEnv = process.env.NODE_ENV;

try {
  envConfig = require(`./env/${nodeEnv}.json`);
} catch {
  envConfig = require("./env/development.json");
}

const { rootStore, env } = createStore({ envConfig });

if (nodeEnv === "development") {
  // for debugging
  console.log(rootStore);
}

const Content = () => {
  const isExpert = location.href.indexOf('/expert/') > 0;
  if(isExpert) {
      return (<ExpertApp />)
  } else {
      return (<App />)
  }
}

const initApp = async () => {
  moment.locale('zh-cn');
  // run Mocks on development
  if (nodeEnv === "development") {
    const { worker } = require("./mocks/browser");
    await worker.start();
  }

  console.log('index', location.href);


  ReactDOM.render(
    <StoreProvider value={rootStore}>
      <Content />
    </StoreProvider>,
    document.getElementById("root")
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

  reportWebVitals();
};

initApp();
